import React, { useEffect, Suspense, lazy } from "react";

import { Route, useLocation, Routes, Navigate } from "react-router-dom";
import CartProvider from "./until/CartProvider";
import { useGtagPageView } from "./Pages/Auth/useGtagPageView";
import { SearchProvider } from "./until/SearchContext";
import { useTokenRefresh } from "./utils/useTokenRefresh";
import { initGA, trackPage } from "./utils/analytics";
import { useTaskTokenExpiry } from "./utils/taskTokenManager";
import AppliedJobs from "./Dashboard/AppliedJobs";
import NinetyDayPlanPage from "./components/NinetyDayPlanPage";
import CASRouteRenderer1 from "./GLMS/CAS/Pages/CASRouteRenderer1";
import FMSRoutes1 from "./GLMS/FMS/Pages/FMSRoutes1";
import CMSroutes1 from "./GLMS/CMS/Pages/CMSroutes1";
import FreelancerForm from "./components/FreelancerForm";
import FloatingCallButton from "./components/FloatingCallButton";
import FloatingGiftOffersButton from "./components/FloatingGiftOffersButton";
import UserOrdersIntegration from "./AskoxyAdmin/UserOrdersIntegration";
import CampaignBlogPage from "./FREEAIBOOK/CampaignBlogPage";
import InvoiceGenerator from "./components/InvoiceGenerator";
import ChatApp from "./ChatScreen/ChatApp";
import VideoCreationPage from "./BharathAIStore/pages/VideoCreation";
import GoldRates from "./components/GoldRates";
import GoldRatesPage from "./components/GoldRatesPage";
import GoldSilverTargets from "./components/GoldSilverTargets";
import FreelancerList from "./components/FreelancerList";
import FreelancersByUserId from "./components/FreelancersByUserId";
import DataReading from "./ChatScreen/DataReading";
import RotaryPosterStudio from "./components/DynamicPosterDesignforRotary";
import RotaryLandingPage from "./components/RotaryLanding";

import { CandidateDetail } from "./AIMockInterview/admin/CandidateDetail";
import ImageCreation from "./BharathAIStore/pages/ImageCreation";
import { AdminDashboard } from "./AIMockInterview/admin/AdminDashboard";
import {
  FeedbackForm,
  MultiLevelSelection,
  ProctoredInterview,
} from "./AIMockInterview";
import CampaignStats from "./components/CampaignStatsAccenture";
import AccentureJobsPage from "./components/AccentureJobsPage";
import AccenturePresentation from "./Dashboard/AccenturePresentation";
import MinisterMeetingPage from "./components/MinisterPage";

import TechmahindraJobsPage from "./components/TechmahindraJobsPage";
import AllCompaniesJobsPage from "./components/AllCompaniesJobsPage";
import LenderBorrowerPartnerLandingPage from "./components/LenderPage";
import GoldLandingPage from "./components/GoldLandingPage";
import JPLLandingPage from "./components/JPL/JPLLandingPage";
import BroadRidgeJobsPage from "./components/BroadRidgepage";
import JobViewPage from "./components/JobsViewPage";
import JobAnalysisResult from "./components/JobAnalysisResult";
import ExamPage from "./components/ExamPage";
import ExamQuestionPage from "./components/ExamQuestionPage";
import ExamResultsPage from "./components/ExamResultsPage";
import Partnersdasboard from "./AskoxyAdmin/Freelanceradmin/Partnersdasboard";
import AdminRequirementList from "./AskoxyAdmin/Freelanceradmin/AdminRequirementList";
import AssignedFreelancerAdmin from "./AskoxyAdmin/Freelanceradmin/AssignedFreelancerslistAdmin";
import EmployeeProtectedRoutes from "./auth/EmployeeProtectedRoute";
import AssignedFreelancersPage from "./FreelanceMarketplace/AssignedFreelancersPage";
import FreelancerProfiles from "./FreelanceMarketplace/FreelancerProfiles";
import RequirementList from "./FreelanceMarketplace/RequirementList";
import EmployeeDashboard from "./FreelanceMarketplace/EmployeeDashboard";
import EmployeeLogin from "./FreelanceMarketplace/EmployeeLogin";
import EmployeeRegister from "./FreelanceMarketplace/EmployeeRegister";
import FinvibeLanding from "./Finvibe/Landing";
import Finvide3DLanding from "./Finvibe/Finvibe3DLanding";
import FinvibeLayout from "./Finvibe/FinvibeLayout";
import FinvibeHomePage from "./Finvibe/components/HomePage";
import FinvibeStage1Page from "./Finvibe/components/Stage1Page";
import FinvibeStage2Page from "./Finvibe/components/Stage2Page";
import FinvibeGenerationPage from "./Finvibe/components/GenerationPage";

import OxyGPT from "./Finvibe/components/Oxyclaude";
import OxyStreamClaude from "./Finvibe/OxyStreamClaude";
import Billing from "./Finvibe/components/Billing";
import SendPollBasedRewards from "./AskoxyAdmin/SendPollBasedRewards";
import ViewPollBasedRewards from "./AskoxyAdmin/ViewPollBasedRewards";
import PlatformRedirect from "./components/PlatformRedirect";
import HiringLandingPage from "./components/HiringLandingPage";
import WalkInJourneyPage from "./components/WalkInJourneyPage";
import DRACertificationLanding from "./components/DRACertificationLanding";
import GCCMate from "./components/GCCMateLandingPage/GCCMate";
import EmployerJobSeekerPage from "./components/JPL/EmployerJobSeekerPage";
import EmployerMentorSection from "./components/JPL/EmployerMentorSection";
import RecruitmentKnightRidersPage from "./components/JPL/RecruitmentKnightRidersPage";
import RoyalJobSeekersPage from "./components/JPL/RoyalJobSeekersPage";
import MarketplaceRaisersPage from "./components/JPL/MarketplaceRaisersPage";
import TrainingInstituteGiantsPage from "./components/JPL/TalentSuperKingsPage";
import LoginAdmin from "./AIMockInterview/admin/LoginAdmin";
import ResumeAIToolsPage from "./components/JPL/ResumeAIToolsPage";
import ReferBuddyPage from "./components/JPL/ReferBuddyPage";
import ProxyLendPage from "./components/Services/ProxyLend";
import RadhAIPage from "./components/talktoceo/radhai";
import TalkToCEO from "./components/talktoceo/TalkToCEO";
import RadhAIVoicePage from "./components/talktoceo/RadhAIVoicePage";
import RadhAICloneAdminPage from "./components/talktoceo/RadhAICloneAdminPage";
import SudheerVakkalagadda from "./AskoxyAdmin/SudheerVakkalagadda";
import RadhAIRAndDPage from "./components/talktoceo/RadhAIRAndDPage";
import RadhAIAdminDashboard from "./components/talktoceo/RadhAIAdminDashboard";
import EmailCampaignLayout, {
  UploadPage,
  SendCampaignPage,
  AllDocumentsPage,
  AllCampaignsRoute,
  ScorecardPage,
  ConversationsPage,
} from "./components/EmailCampaign/index";
import GoogleAnalyticsDashboard from "./components/GoogleAnalyticsDashboard";
import OxyBricksFractionalPage from "./components/FractionalPage";
import Assignedtasksbasedstatus from "./Taskmanagement/Assignedtasksbasedstatus";

import EmiratesNBDAIIntelligenceReport2026 from "./components/EmiratesNBDAIIntelligenceReport2026";
import FABAIIntelligenceReport2026 from "./components/FABAIIntelligenceReport2026";

import ADIBAIIntelligenceReport2026 from "./components/ADIBAIIntelligenceReport2026";
import DIBAIIntelligenceReport2026 from "./components/DIBAIIntelligenceReport2026";
import Finvibe3DLanding from "./Finvibe/Finvibe3DLanding";
import UseCaseEngineDemo from "./Finvibe/UseCaseEngineDemo";
import LiveAIDemo from "./Finvibe/LiveAIDemo";
import ADCBAIIntelligenceReport2026 from "./components/ADCBAIIntelligenceReport2026";
import CBDAIIntelligenceReport2026 from "./components/CBDAIIntelligenceReport2026";
import SIBAIIntelligenceReport2026 from "./components/SIBAIIntelligenceReport2026";
import MashreqAIIntelligenceReport2026 from "./components/MashreqAIIntelligenceReport2026";
import NBFAIIntelligenceReport2026 from "./components/NBFAIIntelligenceReport2026";
import RAKBANKAIIntelligenceReport2026 from "./components/RAKBANKAIIntelligenceReport2026";
import UAEBanksAIIntelligenceHub from "./components/UAEBanksAIIntelligenceHub";
import RadhAIVoicePageCEO from "./components/talktoceo/RadhAIVoicePageLanguage";
import CbsDataPage from "./AskoxyAdmin/CbsDataPage";
import InternshipPage from "./StudyAbroad/InternshipPage";
import BusinessCardLogin from "./BusinessCard/BusinessCardLogin";
import BusinessCardRegister from "./BusinessCard/BusinessCardRegister";
import BusinessCardProtectedRoute from "./auth/BusinessCardProtectedRoute";
import CeoDetailsPage from "./BusinessCard/CeoDetailsPage";
import ProcessBusinessCardPage from "./BusinessCard/ProcessBusinessCardPage";
import CeoUploadDetailsPage from "./BusinessCard/CeoUploadDetailsPage";
import CeoDetailsListPage from "./BusinessCard/CeoDetailsListPage";
import AddLeagueJourney from "./AskoxyAdmin/AddLeagueJourney";
const JobTraining90DaysPage = lazy(
  () => import("./Jobplan/jobplanlandingpage"),
);
const Landingpage = lazy(() => import("./components/Landingpage"));
// const Freerudraksha = lazy(() => import("./components/Services/Freerudraksh"));
const TermsAndConditions = lazy(() => import("./kart/TermsAndConditions"));
const RCSConsentForm = lazy(() => import("./kart/RCSConsentForm"));
const FreeSample = lazy(() => import("./components/Services/FreeSample"));
const FreeAiandGenAi = lazy(() => import("./components/Services/FreeAi&GenAi"));

const MachinesManufacturingServices = lazy(
  () => import("./components/Services/Machines&ManufacturingService"),
);
const LegalService = lazy(() => import("./components/Services/LegalService"));
const MyRotaryServices = lazy(() => import("./components/Services/MyRotary"));
const HiringService = lazy(() => import("./components/Services/HiringService"));
const DesignTemplatesPage = lazy(() => import("./Templates/Templatehome"));
const CAServicesItems = lazy(() => import("./components/CAServicesItems"));
const UniversityPromoCard = lazy(
  () => import("./Templates/UniversityPromoCard"),
);
const PromoCard = lazy(() => import("./Templates/PromoCard"));
const RiceOfferFAQs = lazy(() => import("./Dashboard/Faqs"));
const MyCrypto = lazy(() => import("./Dashboard/MyCrypto"));
const LoanManagementLandingPage = lazy(
  () => import("./components/LoanManagementLandingPage"),
);
const OfferScreen = lazy(() => import("./kart/OfferScreen"));
const AdminSidebar = lazy(() => import("./AskoxyAdmin/Sider"));
const Home = lazy(() => import("./Dashboard/Home"));
const CampaignsAdd = lazy(() => import("./AskoxyAdmin/CampaignsAdd"));
const AllCampaignsDetails = lazy(
  () => import("./AskoxyAdmin/AllCampaignDetail"),
);
const ForgotPasswordPage = lazy(() => import("./Pages/Auth/Forgotpage"));

const InsuranceLLmVoice = lazy(
  () => import("./GenOxy/components/InsuranceLLMVoice"),
);

const AccomidationGpt = lazy(() => import("./components/GPT's/Accomadation"));
const ApplicationSupport = lazy(
  () => import("./components/GPT's/ApplicationSupport"),
);
const AccreditationsRecognization = lazy(
  () => import("./components/GPT's/AccreditationsRecognization"),
);
const CoursesGpt = lazy(() => import("./components/GPT's/CoursesGpt"));
const PreparationGpt = lazy(() => import("./components/GPT's/PreparationGpt"));
const ForeignExchange = lazy(
  () => import("./components/GPT's/ForeignExchange"),
);
const InformationAboutCountries = lazy(
  () => import("./components/GPT's/InformationAboutCountries"),
);
const LoansGpt = lazy(() => import("./components/GPT's/LoansGpt"));
const LogisticsGpt = lazy(() => import("./components/GPT's/LogisticsGpt"));
const PlacementsGpt = lazy(() => import("./components/GPT's/PlacementsGpt"));
const QualificationSpecializationGPT = lazy(
  () => import("./components/GPT's/QualificationSpecializationGPT"),
);
const VisaGpt = lazy(() => import("./components/GPT's/VisaGpt"));
const ReviewsGpt = lazy(() => import("./components/GPT's/ReviewsGpt"));
const ScholarshipGpt = lazy(() => import("./components/GPT's/ScholarshipGpt"));
const UniversityAgents = lazy(
  () => import("./components/GPT's/UniversityAgents"),
);

const University = lazy(() => import("./components/GPT's/UniversityGpt"));
// const RiceSalePage = lazy(() => import("./components/Communities"));
const Admin = lazy(() => import("./AskoxyAdmin/Admin"));
const Climatecrisis = lazy(() => import("./components/Climatecrisis"));
const QR = lazy(() => import("./components/qr"));
const ThankYouPage = lazy(() => import("./components/ThankYouPage"));

const WhatsappLogin = lazy(() => import("./Pages/Auth/WhatsappLogin"));
const WhatsappRegister = lazy(() => import("./Pages/Auth/WhatsappRegister"));
const AllQueries = lazy(() => import("./AskoxyAdmin/AllQueries"));
const RequireAuth = lazy(() => import("./auth/RequireAuth"));
const ItemDisplayPage = lazy(() => import("./kart/itemsdisplay"));
const MyWalletPage = lazy(() => import("./kart/Wallet"));
const CartPage = lazy(() => import("./kart/Cart"));
const MyOrders = lazy(() => import("./kart/Myorders"));
const ProfilePage = lazy(() => import("./kart/Profile"));
const BlogsPage = lazy(() => import("./Dashboard/BlogPage"));
const ServicesPage = lazy(() => import("./Dashboard/ServicesPage"));
const SubscriptionPage = lazy(() => import("./kart/Subscription"));
const WriteToUs = lazy(() => import("./kart/Writetous"));
const TicketHistoryPage = lazy(() => import("./kart/Tickethistory"));
const ManageAddressesPage = lazy(() => import("./kart/Address"));
const CheckoutPage = lazy(() => import("./kart/Checkout"));
const AgentComboOffersPage = lazy(() => import("./kart/AgentComboOffersPage"));
const PrivacyPolicy = lazy(() => import("./kart/Privacypolicy"));
const ReferralPage = lazy(() => import("./kart/Referral"));
const DashboardMain = lazy(() => import("./Dashboard/Dashboardmain"));
const BMVPDF = lazy(() => import("./components/bmvpdf"));
const FreeChatGPTmain = lazy(() => import("./Dashboard/FreechatGPTmain"));
const BMVCOINmain = lazy(() => import("./Dashboard/BMVcoinmain"));
const Content1 = lazy(() => import("./Dashboard/Content"));
const CampaignDetails = lazy(() => import("./components/campaignDetails"));
const FreeChatGPTnormal = lazy(() => import("./Dashboard/Freechatgptnormal"));
const WomensDay = lazy(() => import("./components/WomensDay"));
const Content2 = lazy(() => import("./FREEAIBOOK/Content"));
const HiddenLogin = lazy(() => import("./Pages/Auth/HiddenLogin"));
const SuperAdminComments = lazy(
  () => import("./AskoxyAdmin/SuperAdminComments"),
);
const TestimonialsPage = lazy(() => import("./Dashboard/TestimoinalsOXY"));
const RiceComparison = lazy(() => import("./components/SteanRiceVsRawRice"));
const RegisteredUser = lazy(() => import("./AskoxyAdmin/RegisteredUser"));
const RamMohanDarisaAgents = lazy(
  () => import("./AskoxyAdmin/RamMohanDarisaAgents"),
);
const Login = lazy(() => import("./AskoxyAdmin/Login"));
const RiceGpt = lazy(() => import("./components/RiceGpt"));
const OxyGroup = lazy(() => import("./components/OxygroupPdf"));
const BarcodeScanner = lazy(() => import("./Dashboard/BarcodeScanner"));
const FREEAIANDGENAI = lazy(() => import("./components/AIandGenAi"));
const OxyLoans = lazy(() => import("./components/Services/OxyLoans"));
const UniversityOffers = lazy(() => import("./Dashboard/Offerletter"));
const PinkFunding = lazy(() => import("./components/PinkFunding"));
const CurrentLandingPage = lazy(() => import("./components/CurrentLandinPage"));
const PlanOfTheDay = lazy(() => import("./Taskmanagement/PlanOfTheDay"));

const AllStatusPage = lazy(() => import("./Taskmanagement/AllStatus"));

const TaskAssignedUser = lazy(
  () => import("./Taskmanagement/TaskAssignedUser"),
);
const TaskUpdate = lazy(() => import("./Taskmanagement/EndoftheDay"));
const UserRegister = lazy(() => import("./Taskmanagement/UserRegister"));
const UserLogin = lazy(() => import("./Taskmanagement/UserLogin"));
const CallerHistoryPage = lazy(
  () => import("./AskoxyAdmin/HelpdeskTodayCalls"),
);
// *************************PARTNER START****************************//

const PartnerLogin = lazy(() => import("./PartnerWeb/PartnerLogin"));
const PartnerHome = lazy(() => import("./PartnerWeb/PartnerHome"));
const MainPage = lazy(() => import("./PartnerWeb/MainPage"));
const NewOrders = lazy(() => import("./PartnerWeb/NewOrders"));
const VehicleManagement = lazy(() => import("./PartnerWeb/Addvechicle"));
const OrderDetailsPage = lazy(() => import("./PartnerWeb/OrderDetials"));
const AllOrders = lazy(() => import("./PartnerWeb/AllOrders"));
const DeliveryBoyList = lazy(() => import("./PartnerWeb/DeliveryBoyList"));
const PartnerItemsList = lazy(() => import("./PartnerWeb/PartnerItemsList"));
const DbOrderDetails = lazy(() => import("./PartnerWeb/DbOrderList"));
const AddBlog = lazy(() => import("./AskoxyAdmin/AddBlog"));
const OrderStatsDashboard = lazy(() => import("./AskoxyAdmin/Stats"));
const StockUpdate = lazy(() => import("./AskoxyAdmin/Stockupdate"));
const ContactUs = lazy(() => import("./kart/ContactUs"));
const Register = lazy(() => import("./AskoxyAdmin/Register"));
const AssignedDataPage = lazy(() => import("./AskoxyAdmin/AssignedData"));
const HelpDeskUsersDashboard = lazy(
  () => import("./AskoxyAdmin/HelpDeskUsers"),
);
const DataAssigned = lazy(() => import("./AskoxyAdmin/AskoxyUsers"));
const ReferredData = lazy(() => import("./AskoxyAdmin/RefferedData"));
const TaskProtectedRoute = lazy(() => import("./auth/TaskProtectedRoute"));
const FreeRiceBlog = lazy(() => import("./components/FreeRice"));
const MeyaporeMetro = lazy(() => import("./components/MeyaporeMetro"));
// const { SearchProvider } = lazy(() => import("./until/SearchContext"));
const SearchMain = lazy(() => import("./Dashboard/SearchMain"));
const OrderReport = lazy(() => import("./AskoxyAdmin/OrderReport"));
const LeaveApplicationPage = lazy(
  () => import("./Taskmanagement/LeaveApplicationPage"),
);
const TeamLeaveStatus = lazy(() => import("./Taskmanagement/TeamLeaveStatus"));
const FeedbackDashboard = lazy(() => import("./AskoxyAdmin/FeedBack"));
const MobileNumberUpdate = lazy(
  () => import("./Taskmanagement/EmployeeProfilePage"),
);
const HelpDeskDashboard = lazy(() => import("./AskoxyAdmin/HelpDeskDashboard"));
const RoleBasedBlogsList = lazy(
  () => import("./AskoxyAdmin/RoleBasedBlogsList"),
);
const AddRoleBasedBlog = lazy(() => import("./AskoxyAdmin/AddRoleBasedBlog"));
const ExchangeOrdersPage = lazy(() => import("./PartnerWeb/ExchangeOrders"));
const GSTRiceFAQ = lazy(() => import("./components/GstFAQ"));
const LandingPage = lazy(() => import("./GLMS/LandingPage"));
const CASDashboard = lazy(() => import("./GLMS/CAS/Pages/CASDashboard"));
const CASRouteRenderer = lazy(
  () => import("./GLMS/CAS/Pages/CASRouteRenderer"),
);
const CMSRouteRenderer = lazy(() => import("./GLMS/CMS/Pages/CMSRoutes"));
const CMSDashboard = lazy(() => import("./GLMS/CMS/Pages/CMSDashboard"));
const FMSDashboard = lazy(() => import("./GLMS/FMS/Pages/FMSDashboard"));
const FMSRouteRenderer = lazy(() => import("./GLMS/FMS/Pages/FMSRoutes"));
const JobStreet = lazy(() => import("./GLMS/JobStreet/JobStreet"));
const OrdersByPincode = lazy(() => import("./AskoxyAdmin/Pincodewiseorders"));
const Feedback = lazy(() => import("./components/Feedback"));

const AIBlockchainAndItServices = lazy(
  () => import("./AIBlockchainAndItSev/AIBlockchainAndItServices"),
);
const CACSService = lazy(() => import("./CACSServices/CaCsServices"));
const GoldAndSilverAndDiamond = lazy(
  () => import("./GoldAndSilverAndDiamonds/GoldAndSilverAndDiamonds"),
);
const LoansInvestmentsLandingPage = lazy(
  () => import("./LoansInvestments/LoanInvestmentsLandingPage"),
);
const RealEstate = lazy(() => import("./Real Estate/RealEstate"));
const Nyayagpt = lazy(() => import("./Nyayagpt/Nyayagpt/Nyayagpt"));
const MetroLogin = lazy(() => import("./Pages/Auth/MetroLogin"));
const Rice2RoboEcommers = lazy(
  () => import("./Rice2RoboEcommers/Rice2RoboEcommers"),
);

const HomePage = lazy(() => import("./Retailshop/Pages/Home"));
const ShopFormPage = lazy(() => import("./Retailshop/Pages/ShopFormPage"));
const ShopListPage = lazy(() => import("./Retailshop/Pages/ShopListPage"));
const CarnivalFormPage = lazy(
  () => import("./Retailshop/Pages/CarnivalFormPage"),
);
const CarnivalListPage = lazy(
  () => import("./Retailshop/Pages/CarnivalListPage"),
);
const ShopEditForm = lazy(() => import("./Retailshop/components/ShopEditForm"));
const CarnivalEditPage = lazy(
  () => import("./Retailshop/Pages/CarnivalEditPage"),
);

const CreateAgentMain = lazy(() => import("./AgentStore/CreateAgentMain"));
const CreateAgentStep2 = lazy(() => import("./AgentStore/AgentBusiness"));

const CreateAgentWizard = lazy(() => import("./AgentStore/CreateAgentWizard"));

// *************************STUDY ABRAD****************************//

const UserSelectionPage = lazy(() => import("./StudyAbroad/Homepage"));

const UniversityListPage = lazy(() => import("./StudyAbroad/Universitylist"));
const AllUniversities = lazy(() => import("./StudyAbroad/AllUniversities"));
const LandingPage1 = lazy(() => import("./AIServicesHub/LandingPage"));
const StudyAbroadLandingPage = lazy(
  () => import("./StudyAbroad/StudyAbroadLandingPage"),
);
const StudentMainDashboard = lazy(
  () => import("./StudyAbroad/StudentMainDashboard"),
);
const BlogDetails = lazy(() => import("./components/BlogDetails"));

const GenOxy = lazy(() => import("./GenOxy/Genoxy"));
const RealtimePage = lazy(
  () => import("./GenOxy/components/RealTimeMainscreen"),
);
const VisaVoice = lazy(() => import("./Visavoice/RealTimeMainscreen"));
const JobDetails = lazy(() => import("./components/JobDetails"));
const AddJob = lazy(() => import("./AskoxyAdmin/AddJob"));
const VersionUpdate = lazy(() => import("./PartnerWeb/VersionUpdate"));
const OfferImagesUpdate = lazy(() => import("./PartnerWeb/OfferImagesUpdate"));
const JobsAdminPage = lazy(() => import("./AskoxyAdmin/Alljobdetails"));
const AddReference = lazy(() => import("./PartnerWeb/AddReference"));
const UserAppliedJob = lazy(() => import("./AskoxyAdmin/UserAppliedJobs"));
const StockTable = lazy(() => import("./PartnerWeb/StockDetails"));
const MarketReport = lazy(() => import("./PartnerWeb/Marketreport"));
const FreeAiBookLandingPage = lazy(() => import("./FREEAIBOOK/LandingPage"));

const ChatInterface = lazy(() => import("./components/ChatInterfaceAi"));
const WalletEligibilitySlabs = lazy(
  () => import("./PartnerWeb/CartAmountBasedOrder"),
);
const CreateFromImageText = lazy(
  () => import("./PartnerWeb/CreateFromImageText"),
);
const OurAIVideos = lazy(() => import("./FREEAIBOOK/MasterClasses"));

const CreateAssistant = lazy(
  () => import("./AskoxyAdmin/Assistants/CreatenewAssistant"),
);
const AssistantDashboard = lazy(
  () => import("./AskoxyAdmin/Assistants/Dashboard"),
);
const VectorStorePage = lazy(
  () => import("./AskoxyAdmin/Assistants/VectorStorePage"),
);
const AssistantOverview = lazy(
  () => import("./AskoxyAdmin/Assistants/AssistantOverview"),
);
const FaqLLMSlides = lazy(() => import("./GenOxy/FaqSildes"));
const LLMFAQPage = lazy(() => import("./GenOxy/FaqLLM"));
const AiVideosGenerated = lazy(() => import("./FREEAIBOOK/AiVideosGenerated"));

const AllAgentsPage = lazy(() => import("./AgentStore/AllAgentsPage"));
const AssistantDetails = lazy(
  () => import("./BharathAIStore/pages/AssistantDetails"),
);
const ChatInterface1 = lazy(
  () => import("./BharathAIStore/pages/ChatInterface"),
);
const AiResources = lazy(() => import("./BharathAIStore/pages/AIResources"));

const Layout = lazy(() => import("./BharathAIStore/routes/Landingpage"));
const BharatAgentsStore = lazy(
  () => import("./BharathAIStore/pages/BharatAgentsStore"),
);
const BananaImageGenerate = lazy(
  () => import("./AgentStore/BananaImageGenerate"),
);
const InsuranceAgentsPage = lazy(
  () => import("./BharathAIStore/pages/InsuranceAgentsPage"),
);
const AwardsRewardsVideo = lazy(
  () => import("./BharathAIStore/pages/AwardsRewardsVideo"),
);
const CartCaCsService = lazy(() => import("./components/CartCaCsService"));
const ServiceCAList = lazy(() => import("./components/ServiceCAList"));
const ServiceDashboard = lazy(() => import("./components/ServiceDashboard"));
const EmployeeInteractions = lazy(
  () => import("./Taskmanagement/EmployeeInstructions"),
);
const EmployeeViewChat = lazy(
  () => import("./Taskmanagement/EmployeeChatView"),
);
const HealthcareAgentsPage = lazy(
  () => import("./BharathAIStore/pages/Healthcareagents"),
);
const RemoveTrailingSlash = lazy(() => import("./auth/RemoveTrailingSlash"));
const AdminMyAgentsPage = lazy(
  () => import("./BharathAIStore/pages/AdminMyAgentsPage"),
);
const RadhaHiddenAgents = lazy(
  () => import("./BharathAIStore/pages/RadhaHiddenAgents"),
);
const AdminTasks = lazy(() => import("./Taskmanagement/AdminTasks"));
const AllKukatpallyDataPage = lazy(
  () => import("./AskoxyAdmin/kukatapallyData"),
);
const ChatBasedAgent = lazy(
  () => import("./BharathAIStore/pages/chatbasedAgent"),
);

const WeAreHiringAdd = lazy(() => import("./AskoxyAdmin/WeAreHiringAdd"));
const AdvocatesDataPage = lazy(() => import("./AskoxyAdmin/Advoatedata"));
const HiringPages = lazy(() => import("./Dashboard/hiringpages"));
const KukatpallyAssignedDataPage = lazy(
  () => import("./AskoxyAdmin/KukatapallyAssignedData"),
);
const CelebShieldPage = lazy(() => import("./components/celebshieldpage"));
const QuickAgentCreate = lazy(
  () => import("./BharathAIStore/pages/Agentcreation"),
);
const TestStore = lazy(() => import("./BharathAIStore/pages/TestStore"));
const TestAgentDetails = lazy(
  () => import("./BharathAIStore/pages/TestAgentDetails"),
);
const PaymentCashfree = lazy(() => import("./AgentStore/PaymentCashfree"));
const AllAIStore = lazy(() => import("./AIStores/AllAistore"));
const AllAIStores = lazy(() => import("./AIStores/AllAistores"));
const TalwarDataPage = lazy(() => import("./AskoxyAdmin/TalwarData"));
const TalwarAssignedDataPage = lazy(
  () => import("./AskoxyAdmin/TalwarAssignedDataPage"),
);
const ApiDocs = lazy(() => import("./components/ApiDocs"));
const InterviewPage = lazy(() => import("./AIMockInterview/interview"));
const BulkInvite = lazy(() => import("./kart/BulkInvite"));
const MumbaiDataPage = lazy(() => import("./AskoxyAdmin/MumbaiDataPage"));
const AgenticAi = lazy(() => import("./components/AgenticAi"));
const AgentStoreManager = lazy(() => import("./components/AistoreCreation"));
const GmailContactsScreen = lazy(() => import("./kart/GoogleContact"));
const AgentCreationSteps = lazy(
  () => import("./components/AgentCreationSteps"),
);
const TripPlanner = lazy(() => import("./AITripPlanner/TripPlanner"));
const TaxInvoice = lazy(() => import("./components/TaxInvoice"));
const AccentureServices = lazy(
  () => import("./components/CampaignStatsAccenture"),
);

// Simple centered loader component
const LoadingSpinner = React.memo(() => {
  React.useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      .loader {
        width: 50px;
        aspect-ratio: 1;
        display: grid;
        border: 4px solid #0000;
        border-radius: 50%;
        border-right-color: #5c3391;
        animation: l15 1s infinite linear;
      }
      .loader::before,
      .loader::after {
        content: "";
        grid-area: 1/1;
        margin: 2px;
        border: inherit;
        border-radius: 50%;
        animation: l15 2s infinite;
      }
      .loader::after {
        margin: 8px;
        animation-duration: 3s;
      }
      @keyframes l15 {
        100% { transform: rotate(1turn); }
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f8f9fa",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div className="loader" />
      <div style={{ fontSize: "18px", color: "#333", marginTop: "16px" }}>
        Loading...
      </div>
    </div>
  );
});

const App: React.FC = () => {
  const location = useLocation();

  useGtagPageView();

  useTokenRefresh();

  useTaskTokenExpiry();
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (
      params.get("utm_source") ||
      params.get("utm_medium") ||
      params.get("utm_campaign")
    ) {
      const utmData = {
        source: params.get("utm_source"),
        medium: params.get("utm_medium"),
        campaign: params.get("utm_campaign"),
        content: params.get("utm_content"),
        term: params.get("utm_term"),
        fullUrl: window.location.href,
        pagePath: window.location.pathname,
      };

      console.log("UTM DATA:", utmData);
      localStorage.setItem("utmData", JSON.stringify(utmData));

      if ((window as any).gtag) {
        (window as any).gtag("event", "utm_landing", {
          page_location: window.location.href,
          page_path: window.location.pathname,
          utm_source: utmData.source,
          utm_medium: utmData.medium,
          utm_campaign: utmData.campaign,
          utm_content: utmData.content,
          utm_term: utmData.term,
        });
      }
    }
  }, []);
  // useEffect(() => {
  //     const rt = getRefreshToken();
  //     if (rt) {
  //       console.log("Refresh token found on app load, attempting refresh...");
  //       // You can trigger an immediate token refresh here if needed
  //     } else {
  //       console.log("No refresh token found on app load.");
  //     }
  //   }, []);

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    trackPage(location.pathname);
  }, [location]);

  useEffect(() => {
    const validEntryPoints = [
      "/",
      "/future",
      "/freerice",
      "/glms",
      "/miyapurmetro",
      "/los",
      "/fms",
      "/cms",
      "/radhai",
      "/aiblockchainanditservices",
      "/caandcaservices",
      "/goldandsilveranddiamonds",
      "/loansinvestments",
      "/realestate",
      "/rice2roboecommers",
      "/nyayagpt",
      "/student-home",
      "/studyabroad",
      "/FreeAIBook",
      "/genoxyai-services",
      "/bharath-aistore",
      "/interview",
      "/accenture/jobs",
      "/accenturestats",
      "/techmahindra/jobs",
      "/allcompanies/jobs",
      "/broadridge/jobs",
      "/credera/jobs",
      "/viewjobdetails/default/ALL",
    ];
    if (validEntryPoints.includes(location.pathname)) {
      console.log("Setting entryPoint:", location.pathname); // Debug log
      localStorage.setItem("entryPoint", location.pathname);
    }
  }, [location.pathname]);
  const isDashboardHomeRoute = location.pathname === "/main/dashboard/home";
  const isRootRoute = location.pathname === "/";
  const isLoggedIn = !!localStorage.getItem("userId");
  const isRestrictedRoute = () => {
    const currentPath = location.pathname;
    return (
      // Login pages
      currentPath === "/admin" ||
      currentPath === "/partnerlogin" ||
      currentPath === "/userlogin" ||
      currentPath === "/employee-login" ||
      currentPath === "/employee-register" ||
      // Employee routes
      currentPath === "/employee-dashboard" ||
      currentPath === "/employee-requirement-list" ||
      currentPath === "/employee-freelancers" ||
      // Employee/Internal routes
      currentPath.startsWith("/userPanelLayout") ||
      currentPath.startsWith("/goldrates") ||
      currentPath.startsWith("/all-different-gold-rates") ||
      currentPath.startsWith("/allgoldrates") ||
      currentPath.startsWith(
        "/employee-freelancers/:companyId/:requirementId",
      ) ||
      currentPath.startsWith("/radha/adcb-ai-intelligence") ||
      currentPath.startsWith("/radha/emirates-nbd-ai-intelligence") ||
      currentPath.startsWith("/radha/fab-ai-intelligence") ||
      currentPath.startsWith("/employee-assigned-freelancers/:companyId") ||
      currentPath.startsWith("/radha/adib-ai-intelligence") ||
      currentPath.startsWith("/radha/dib-ai-intelligence") ||
      currentPath.startsWith("/radha/cbd-ai-intelligence") ||
      currentPath.startsWith("/radha/sib-ai-intelligence") ||
      currentPath.startsWith("/radha/mashreq-ai-intelligence") ||
      currentPath.startsWith("/radha/nbf-ai-intelligence") ||
      currentPath.startsWith("/radha/rakbank-ai-intelligence") ||
      currentPath.startsWith("/smartlock") ||
      currentPath.startsWith("/radha/uae-banks-ai-intelligence") ||
      currentPath.startsWith("/planoftheday") ||
      currentPath.startsWith("/userinstructionsview") ||
      currentPath.startsWith("/taskmanagement") ||
      currentPath.startsWith("/taskupdated") ||
      currentPath.startsWith("/email-campaign") ||
      currentPath.startsWith("/leaveapproval") ||
      currentPath.startsWith("/leavestatus") ||
      currentPath.startsWith("/all-statuses") ||
      currentPath.startsWith("/assigned-task") ||
      currentPath.startsWith("/techmahindra/jobs") ||
      currentPath.startsWith("/allcompanies/jobs") ||
      currentPath.startsWith("/credera/jobs") ||
      currentPath.startsWith("/taskassigneduser") ||
      currentPath.startsWith("/broadridge/jobs") ||
      currentPath.startsWith("/employeeprofile") ||
      // Partner routes
      currentPath.startsWith("/home") ||
      // Admin routes
      currentPath.startsWith("/admin") ||
      currentPath.startsWith("/glms") ||
      currentPath.startsWith("/adminRegister") ||
      currentPath.startsWith("/accenture/jobs") ||
      currentPath.startsWith("/accenturestats") ||
      currentPath.startsWith("/accenture-presentation") ||
      currentPath.startsWith("/interview") ||
      currentPath.startsWith("/oxybfsai-landing") ||
      currentPath.startsWith("/oxybfsai") ||
      currentPath.startsWith("/finvibe-code-builder") ||
      currentPath.startsWith("/insurvibe-code-builder") ||
      currentPath.startsWith("/radhai-admin/") ||
      currentPath.startsWith("/radha/uae-banks-ai-intelligence") ||
      currentPath.startsWith("/radhai-admin") ||
      currentPath.startsWith("/use-case-engine") ||
      currentPath.startsWith("/live-ai-demo") ||
      currentPath.startsWith("/radhai") ||
      currentPath.startsWith("/talktoceo") ||
      currentPath.startsWith("/radhai-connect") ||
      currentPath.startsWith("/radhAI") ||
      currentPath.startsWith("/radhai-admin") ||
      currentPath.startsWith("/generate") ||
      currentPath.startsWith("/generate/:id") ||
      currentPath.startsWith("/stage2/:sessionId") ||
      currentPath.startsWith("/oxygpt/claude")
    );
  };

  return (
    <CartProvider>
      <SearchProvider>
        <RemoveTrailingSlash />

        <Suspense fallback={<LoadingSpinner />}>
          <div className="App">
            {/* {localStorage.getItem("userId") &&
              !isRestrictedRoute() && <FloatingCallButton />}
            {localStorage.getItem("userId") &&
              !isRestrictedRoute() && <FloatingGiftOffersButton />} */}
            {isLoggedIn && isRootRoute && <FloatingCallButton />}

            {isLoggedIn && isDashboardHomeRoute && (
              <>
                <FloatingCallButton />
                <FloatingGiftOffersButton />
              </>
            )}
            <Routes>
              <Route path="/shopretail" element={<HomePage />} />

              <Route path="/shop-form" element={<ShopFormPage />} />
              <Route path="/shop-list" element={<ShopListPage />} />
              <Route path="/shop-edit/:id" element={<ShopEditForm />} />
              <Route path="/90dayjobplan" element={<JobTraining90DaysPage />} />
              <Route path="/carnival-form" element={<CarnivalFormPage />} />
              <Route path="/carnival-list" element={<CarnivalListPage />} />
              <Route path="/Oxygpt" element={<OxyGPT />} />
              <Route path="/oxygpt/claude" element={<OxyStreamClaude />} />
              <Route path="/oxygpt/share/:sessionId" element={<OxyGPT />} />
              <Route path="/finvibe" element={<Finvibe3DLanding />} />
              <Route path="/use-case-engine" element={<UseCaseEngineDemo />} />
              <Route path="/live-ai-demo" element={<LiveAIDemo />} />
              <Route path="/adcb" element={<ADCBAIIntelligenceReport2026 />} />
              <Route path="/oxybfsai" element={<Billing />} />
              <Route path="/oxybfsai-landing" element={<Finvide3DLanding />} />
              <Route path="/finvibe" element={<Finvibe3DLanding />} />
              <Route path="/use-case-engine" element={<UseCaseEngineDemo />} />
              <Route path="/live-ai-demo" element={<LiveAIDemo />} />
              <Route path="/adcb" element={<ADCBAIIntelligenceReport2026 />} />
              <Route path="/oxybfsai" element={<Billing />} />
              <Route path="/oxybfsai-landing" element={<Finvide3DLanding />} />

              {/* OXY BFSAI Engine — full layout with fixed header */}
              <Route element={<FinvibeLayout />}>
                <Route path="/oxybfsai-engine" element={<FinvibeHomePage />} />
                <Route path="/generate" element={<FinvibeStage1Page />} />
                <Route
                  path="/stage2/:sessionId"
                  element={<FinvibeStage2Page />}
                />
                <Route
                  path="/generating/:sessionId"
                  element={<FinvibeGenerationPage />}
                />
              </Route>

              <Route
                path="/finvibe-code-builder"
                element={<FinvibeLanding />}
              />
              <Route
                path="/insurvibe-code-builder"
                element={<FinvibeLanding />}
              />
              <Route path="/login-admin" element={<LoginAdmin />} />
              <Route
                path="/carnivals/edit/:id"
                element={<CarnivalEditPage />}
              />
              {/* <Route path="/freelancers" element={<FreelancerList />} /> */}

              <Route path="/ThefanofOG" element={<BananaImageGenerate />} />

              <Route path="/paymentcashfree" element={<PaymentCashfree />} />
              <Route path="/interview" element={<InterviewPage />} />
              <Route
                path="/admin/candidate/:userId"
                element={<CandidateDetail />}
              />
              <Route
                path="/admin/interviewdashboard"
                element={<AdminDashboard />}
              />
              <Route
                path="/multi-level-select"
                element={<MultiLevelSelection />}
              />
              <Route path="/multi-interview" element={<ProctoredInterview />} />
              <Route path="/feedback" element={<FeedbackForm />} />
              <Route path="/offer" element={<OfferScreen />} />
              <Route path="/tripplanner" element={<TripPlanner />} />
              <Route path="/invoice" element={<InvoiceGenerator />} />
              <Route path="/tax-invoice" element={<TaxInvoice />} />
              <Route path="/chat" element={<ChatApp />} />
              <Route path="/goldrates" element={<GoldRates />} />
              <Route path="/smartlock" element={<GoldSilverTargets />} />
              <Route path="/allgoldrates" element={<GoldRatesPage />} />
              <Route path="/oxyinsurance" element={<DataReading />} />
              <Route
                path="/it-minister-vision"
                element={<MinisterMeetingPage />}
              />
              <Route path="/gccmate" element={<GCCMate />} />
              <Route path="/employers" element={<EmployerJobSeekerPage />} />
              <Route
                path="/radha/uae-banks-ai-intelligence"
                element={<UAEBanksAIIntelligenceHub />}
              />
              <Route path="/radhAI" element={<RadhAIPage />} />
              <Route path="/radhai-connect" element={<RadhAIVoicePage />} />
              <Route path="/ceoclonevoice" element={<RadhAICloneAdminPage />} />

              <Route
                path="/radhai-admin/*"
                element={<RadhAIAdminDashboard />}
              />

              <Route path="/radhai-RandD" element={<RadhAIRAndDPage />} />
              <Route path="/talktoceo" element={<TalkToCEO />} />
              <Route path="/internships" element={<InternshipPage />} />
              <Route
                path="/radhai-assistant"
                element={<RadhAIVoicePageCEO />}
              />
              <Route path="/circleLend" element={<ProxyLendPage />} />
              <Route path="/resume-ai" element={<ResumeAIToolsPage />} />
              <Route path="/mentors" element={<EmployerMentorSection />} />
              <Route path="/refer-buddy" element={<ReferBuddyPage />} />
              <Route path="/job-seekers" element={<RoyalJobSeekersPage />} />
              <Route
                path="/recruitment-knight-riders"
                element={<RecruitmentKnightRidersPage />}
              />
              <Route
                path="/talent-super-kings"
                element={<TrainingInstituteGiantsPage />}
              />
              <Route
                path="/marketplace-raisers"
                element={<MarketplaceRaisersPage />}
              />
              <Route path="/accenturestats" element={<CampaignStats />} />
              <Route path="/accenture/jobs" element={<AccentureJobsPage />} />
              {/* <Route path="/credera/jobs" element={<CrederaJobsPage />} /> */}
              <Route
                path="/techmahindra/jobs"
                element={<TechmahindraJobsPage />}
              />
              <Route path="/broadridge/jobs" element={<BroadRidgeJobsPage />} />
              <Route
                path="/allcompanies/jobs"
                element={<AllCompaniesJobsPage />}
              />
              <Route
                path="/accenture-presentation"
                element={<AccenturePresentation />}
              />
              <Route
                path="/rotarydistrict3150AiAgent"
                element={<RotaryLandingPage />}
              />
              <Route
                path="/accenture-services"
                element={<AccentureServices />}
              />
              <Route
                path="/dynamic-rotaryposter"
                element={<RotaryPosterStudio />}
              />
              <Route
                path="/ninetydayplan"
                element={
                  <RequireAuth>
                    <NinetyDayPlanPage />
                  </RequireAuth>
                }
              />
              <Route
                path="/campaign/:campaignId"
                element={<CampaignBlogPage />}
              />

              {/* NOTE: These are your existing relative routes (kept same) */}
              <Route path="dashboard/:tab" element={<DashboardMain />} />
              <Route
                path="services/freeai-genai"
                element={<FreeAiandGenAi />}
              />
              <Route path="services/:id/:type" element={<CampaignDetails />} />
              <Route path="blog/:id/:type" element={<BlogDetails />} />
              <Route path="jobdetails" element={<JobDetails />} />
              <Route path="viewjobdetails" element={<JobViewPage />} />
              <Route path="viewjobdetails/:id" element={<JobViewPage />} />
              <Route
                path="viewjobdetails/:id/:company"
                element={<JobViewPage />}
              />
              <Route path="caserviceitems" element={<CAServicesItems />} />
              <Route path="metroLogin" element={<MetroLogin />} />
              <Route
                path="agentCreationSteps"
                element={<AgentCreationSteps />}
              />
              <Route
                path="services/Freechatgpt"
                element={<FreeChatGPTmain />}
              />
              <Route path="services/myrotary" element={<MyRotaryServices />} />
              <Route path="services/bmvcoin" element={<BMVCOINmain />} />
              <Route
                path="services/freesample-steelcontainer"
                element={<FreeSample />}
              />
              <Route
                path="services/machines-manufacturing"
                element={<MachinesManufacturingServices />}
              />
              <Route path="service/oxyloans-service" element={<OxyLoans />} />
              <Route path="services/legalservice" element={<LegalService />} />
              <Route
                path="services/we-are-hiring"
                element={<HiringService />}
              />

              {/* ===================================================== */}
              {/* ✅ AUTH ROUTES (WhatsApp Login/Register) */}
              {/* ===================================================== */}
              <Route path="/whatsapplogin" element={<WhatsappLogin />} />
              <Route path="/whatsappregister" element={<WhatsappRegister />} />

              {/* ===================================================== */}
              {/* ✅ OTHER PUBLIC ROUTES */}
              {/* ===================================================== */}
              <Route path="/freerice" element={<FreeRiceBlog />} />
              <Route
                path="/usercreateaistore"
                element={<AgentStoreManager />}
              />
              <Route path="/userFeedback" element={<Feedback />} />
              <Route path="/miyapurmetro" element={<MeyaporeMetro />} />
              <Route path="/aiassistant" element={<ChatInterface />} />

              <Route path="/userregister" element={<UserRegister />} />
              <Route path="/userlogin" element={<UserLogin />} />
              {/* ✅ FREELANCE MARKETPLACE ROUTES (EMPLOYEE/COMPANY) */}
              {/* ===================================================== */}
              <Route path="/employee-login" element={<EmployeeLogin />} />
              <Route path="/employee-register" element={<EmployeeRegister />} />
              <Route
                path="/employee-dashboard"
                element={
                  <EmployeeProtectedRoutes>
                    <EmployeeDashboard />
                  </EmployeeProtectedRoutes>
                }
              />
              <Route
                path="/employee-requirement-list"
                element={
                  <EmployeeProtectedRoutes>
                    <RequirementList />
                  </EmployeeProtectedRoutes>
                }
              />
              <Route
                path="/employee-freelancers/:companyId/:requirementId"
                element={
                  <EmployeeProtectedRoutes>
                    <FreelancerProfiles />
                  </EmployeeProtectedRoutes>
                }
              />
              <Route
                path="/employee-assigned-freelancers/:companyId"
                element={
                  <EmployeeProtectedRoutes>
                    <AssignedFreelancersPage />
                  </EmployeeProtectedRoutes>
                }
              />
              {/* ===================================================== */}
              {/* ✅ PUBLIC PAGES UNDER LAYOUT */}
              {/* ===================================================== */}
              <Route element={<Layout />}>
                <Route
                  path="/bharath-aistore"
                  element={<BharatAgentsStore />}
                />
                <Route path="/all-ai-stores" element={<AllAIStores />} />
                <Route path="/ai-store/:storeSlug" element={<AllAIStore />} />
                <Route
                  path="/ai-store/:storeSlug/:type"
                  element={<AllAIStore />}
                />
                <Route
                  path="/bharath-aistore/insurance"
                  element={<InsuranceAgentsPage />}
                />
                <Route
                  path="/bharath-aistore/RadhaAgents"
                  element={<AdminMyAgentsPage />}
                />
                <Route
                  path="/bharath-aistore/hiddenagents"
                  element={<RadhaHiddenAgents />}
                />
                <Route
                  path="/bharath-aistore/healthcare"
                  element={<HealthcareAgentsPage />}
                />
                <Route
                  path="/awards-rewards"
                  element={<AwardsRewardsVideo />}
                />
                <Route
                  path="/bharath-aistore/ai-initiatives"
                  element={<AiResources />}
                />
              </Route>
              <Route path="/image-creator" element={<ImageCreation />} />
              <Route path="/video-creator" element={<VideoCreationPage />} />

              {/* ✅ MORE PUBLIC ROUTES */}

              <Route path="/jobstreet" element={<JobStreet />} />
              <Route
                path="/:id/:agentId/:agentname"
                element={<AssistantDetails />}
              />
              <Route path="/myblogs" element={<BlogsPage />} />
              <Route path="/wearehiring" element={<HiringPages />} />
              <Route path="/myservices" element={<ServicesPage />} />
              <Route path="/celebshield" element={<CelebShieldPage />} />
              <Route
                path="/termsandconditions"
                element={<TermsAndConditions />}
              />
              <Route
                path="/loansandinvest"
                element={<LenderBorrowerPartnerLandingPage />}
              />
              <Route path="/oxygold" element={<GoldLandingPage />} />
              <Route path="/jobspremierleague" element={<JPLLandingPage />} />
              <Route path="/fpl" element={<OxyBricksFractionalPage />} />

              <Route path="/rcsconsentform" element={<RCSConsentForm />} />
              <Route
                path="/loanmanagement"
                element={<LoanManagementLandingPage />}
              />
              <Route path="/platform-redirect" element={<PlatformRedirect />} />

              {/* LOS / Dashboards */}
              <Route path="/los" element={<CASDashboard />} />
              <Route
                path="/los/:useCaseId/:type"
                element={<CASRouteRenderer />}
              />
              <Route
                path="/lo-system/:useCaseId/:type"
                element={<CASRouteRenderer1 />}
              />
              <Route
                path="/fm-system/:useCaseId/:type"
                element={<FMSRoutes1 />}
              />
              <Route
                path="/cm-system/:useCaseId/:type"
                element={<CMSroutes1 />}
              />
              <Route path="/cms" element={<CMSDashboard />} />
              <Route
                path="/cms/:useCaseId/:type"
                element={<CMSRouteRenderer />}
              />
              <Route path="/fms" element={<FMSDashboard />} />
              <Route
                path="/fms/:useCaseId/:type"
                element={<FMSRouteRenderer />}
              />
              <Route path="/glms" element={<LandingPage />} />

              {/* AI Videos / Content */}
              <Route path="/ai-masterclasses" element={<OurAIVideos />} />
              <Route path="/ai-videos" element={<AiVideosGenerated />} />
              <Route path="/genoxyai-services" element={<LandingPage1 />} />

              {/* Free AI Book */}
              <Route path="/freeaibook" element={<Content2 />}>
                <Route index element={<FreeAiBookLandingPage />} />
                {/* <Route
                  path="view"
                  element={
                    <ProtectedRoute>
                      <FreeAiBook />
                    </ProtectedRoute>
                  }
                /> */}
              </Route>
              {/* GenOxy */}
              <Route
                path="/aiblockchainanditservices"
                element={<AIBlockchainAndItServices />}
              />
              <Route path="/insurancevoice" element={<InsuranceLLmVoice />} />
              <Route path="/genoxy" element={<GenOxy />} />
              <Route
                path="/genoxy/tie"
                element={<Navigate to="/genoxy/chat?a=tie-llm" replace />}
              />
              <Route
                path="/genoxy/klm"
                element={
                  <Navigate
                    to={
                      "/genoxy/chat?a=" + encodeURIComponent("klm-fashions LLM")
                    }
                    replace
                  />
                }
              />
              <Route path="/genoxy/chat" element={<GenOxy />} />
              <Route path="/genoxy/llm-faqs" element={<LLMFAQPage />} />
              <Route path="/genoxy/faqslide" element={<FaqLLMSlides />} />

              {/* Voice Assistants */}
              <Route
                path="/voiceAssistant"
                element={<Navigate to="/voiceAssistant/welcome" replace />}
              />
              <Route
                path="/voiceAssistant/:screen"
                element={<RealtimePage />}
              />
              <Route path="/caandcsservices" element={<CACSService />} />
              <Route
                path="/visavoice"
                element={<Navigate to="/visavoice/welcome" replace />}
              />
              <Route path="/visavoice/:screen" element={<VisaVoice />} />

              {/* Other Landing / Service pages */}
              <Route
                path="/goldandsilveranddiamonds"
                element={<GoldAndSilverAndDiamond />}
              />
              <Route
                path="/loansinvestments"
                element={<LoansInvestmentsLandingPage />}
              />
              <Route path="/realestate" element={<RealEstate />} />
              <Route
                path="/rice2roboecommers"
                element={<Rice2RoboEcommers />}
              />
              <Route path="/nyayagpt" element={<Nyayagpt />} />
              <Route path="/gstonrice" element={<GSTRiceFAQ />} />
              <Route
                path="/business-card/login"
                element={<BusinessCardLogin />}
              />
              <Route
                path="/business-card/register"
                element={<BusinessCardRegister />}
              />
              <Route
                path="/business-card/ceo-details"
                element={
                  <BusinessCardProtectedRoute>
                    <CeoDetailsPage />
                  </BusinessCardProtectedRoute>
                }
              />
              <Route
                path="/business-card/process"
                element={
                  <BusinessCardProtectedRoute>
                    <ProcessBusinessCardPage />
                  </BusinessCardProtectedRoute>
                }
              />
              <Route
                path="/business-card/upload-details"
                element={
                  <BusinessCardProtectedRoute>
                    <CeoUploadDetailsPage />
                  </BusinessCardProtectedRoute>
                }
              />
              <Route
                path="/business-card/ceo-details-list"
                element={
                  <BusinessCardProtectedRoute>
                    <CeoDetailsListPage />
                  </BusinessCardProtectedRoute>
                }
              />
              {/* ✅ FREELANCE MARKETPLACE ROUTES (EMPLOYEE/COMPANY) */}
              {/* ===================================================== */}
              <Route path="/employee-login" element={<EmployeeLogin />} />
              <Route path="/employee-register" element={<EmployeeRegister />} />
              <Route
                path="/employee-dashboard"
                element={
                  <EmployeeProtectedRoutes>
                    <EmployeeDashboard />
                  </EmployeeProtectedRoutes>
                }
              />
              <Route
                path="/employee-requirement-list"
                element={
                  <EmployeeProtectedRoutes>
                    <RequirementList />
                  </EmployeeProtectedRoutes>
                }
              />
              <Route
                path="/employee-freelancers/:companyId/:requirementId"
                element={
                  <EmployeeProtectedRoutes>
                    <FreelancerProfiles />
                  </EmployeeProtectedRoutes>
                }
              />
              <Route
                path="/employee-assigned-freelancers/:companyId"
                element={
                  <EmployeeProtectedRoutes>
                    <AssignedFreelancersPage />
                  </EmployeeProtectedRoutes>
                }
              />
              {/* Employee / Internal */}
              <Route
                path="/userPanelLayout"
                element={
                  <TaskProtectedRoute>
                    <PlanOfTheDay />
                  </TaskProtectedRoute>
                }
              />
              <Route
                path="/planoftheday"
                element={
                  <TaskProtectedRoute>
                    <PlanOfTheDay />
                  </TaskProtectedRoute>
                }
              />
              <Route
                path="/userinstructionsview"
                element={
                  <TaskProtectedRoute>
                    <EmployeeInteractions />
                  </TaskProtectedRoute>
                }
              />
              <Route
                path="/employeeprofile"
                element={
                  <TaskProtectedRoute>
                    <MobileNumberUpdate />
                  </TaskProtectedRoute>
                }
              />
              <Route
                path="/taskmanagement/chatview/:id"
                element={
                  <TaskProtectedRoute>
                    <EmployeeViewChat />
                  </TaskProtectedRoute>
                }
              />
              <Route
                path="/taskupdated"
                element={
                  <TaskProtectedRoute>
                    <TaskUpdate />
                  </TaskProtectedRoute>
                }
              />
              <Route
                path="/leaveapproval"
                element={
                  <TaskProtectedRoute>
                    <LeaveApplicationPage />
                  </TaskProtectedRoute>
                }
              />
              <Route
                path="/leavestatus"
                element={
                  <TaskProtectedRoute>
                    <TeamLeaveStatus />
                  </TaskProtectedRoute>
                }
              />
              <Route
                path="/all-statuses"
                element={
                  <TaskProtectedRoute>
                    <AllStatusPage />
                  </TaskProtectedRoute>
                }
              />
              <Route
                path="/assigned-task"
                element={
                  <TaskProtectedRoute>
                    <AdminTasks />
                  </TaskProtectedRoute>
                }
              />
              <Route
                path="/assigned-task-status"
                element={
                  <TaskProtectedRoute>
                    <Assignedtasksbasedstatus />
                  </TaskProtectedRoute>
                }
              />
              <Route
                path="/taskassigneduser"
                element={
                  <TaskProtectedRoute>
                    <TaskAssignedUser />
                  </TaskProtectedRoute>
                }
              />

              {/* Auth / Help */}
              <Route path="/secure-login" element={<HiddenLogin />} />
              <Route path="/forgot" element={<ForgotPasswordPage />} />
              <Route path="/contactus" element={<ContactUs />} />
              <Route path="/faqs" element={<RiceOfferFAQs />} />

              {/* Study Abroad */}
              <Route path="/studyabroad" element={<StudyAbroadLandingPage />} />
              <Route path="/all-universities" element={<AllUniversities />} />
              <Route
                path="/student-dashboard"
                element={<StudentMainDashboard />}
              />
              <Route path="/student-home" element={<UserSelectionPage />} />
              <Route
                path="/google-analytics-dashboard"
                element={<GoogleAnalyticsDashboard />}
              />
              <Route
                path="/listofuniversities"
                element={<UniversityListPage />}
              />

              {/* Misc */}
              <Route path="/qrcode" element={<QR />} />
              <Route path="/agenticai" element={<AgenticAi />} />
              <Route
                path="/bharat-agentbusiness"
                element={<CreateAgentStep2 />}
              />
              <Route path="/oxygroup" element={<OxyGroup />} />
              <Route path="/pinkfunding" element={<PinkFunding />} />
              <Route path="/climatecrisis" element={<Climatecrisis />} />
              <Route path="/thank-you" element={<ThankYouPage />} />
              <Route
                path="/freechatgptnormal"
                element={<FreeChatGPTnormal />}
              />
              <Route
                path="/proud-lender/testimonials"
                element={<TestimonialsPage />}
              />
              <Route path="/templates" element={<DesignTemplatesPage />} />
              <Route path="/template1" element={<UniversityPromoCard />} />
              <Route path="/template2" element={<PromoCard />} />
              <Route path="/steamricevsrawrice" element={<RiceComparison />} />
              <Route
                path="/aiandgenaivsverficationandvalidation"
                element={<FREEAIANDGENAI />}
              />
              <Route path="/future" element={<Landingpage />} />
              <Route path="/apidocs" element={<ApiDocs />} />
              <Route path="/womensday" element={<WomensDay />} />

              <Route
                path="/radha/emirates-nbd-ai-intelligence"
                element={<EmiratesNBDAIIntelligenceReport2026 />}
              />
              <Route
                path="/radha/fab-ai-intelligence"
                element={<FABAIIntelligenceReport2026 />}
              />
              <Route
                path="/radha/uae-banks-ai-intelligence"
                element={<UAEBanksAIIntelligenceHub />}
              />

              <Route
                path="/radha/adib-ai-intelligence"
                element={<ADIBAIIntelligenceReport2026 />}
              />
              <Route
                path="/radha/dib-ai-intelligence"
                element={<DIBAIIntelligenceReport2026 />}
              />

              <Route
                path="/radha/adcb-ai-intelligence"
                element={<ADCBAIIntelligenceReport2026 />}
              />
              <Route
                path="/radha/cbd-ai-intelligence"
                element={<CBDAIIntelligenceReport2026 />}
              />
              <Route
                path="/radha/rakbank-ai-intelligence"
                element={<RAKBANKAIIntelligenceReport2026 />}
              />
              <Route
                path="/radha/nbf-ai-intelligence"
                element={<NBFAIIntelligenceReport2026 />}
              />
              <Route
                path="/radha/mashreq-ai-intelligence"
                element={<MashreqAIIntelligenceReport2026 />}
              />
              <Route
                path="/radha/sib-ai-intelligence"
                element={<SIBAIIntelligenceReport2026 />}
              />
              <Route path="/privacypolicy" element={<PrivacyPolicy />} />
              <Route path="/bmvpdf" element={<BMVPDF />} />

              <Route path="/teststore" element={<TestStore />} />
              <Route
                path="/teststore/assistant/:id/:agentId"
                element={<TestAgentDetails />}
              />
              <Route path="/email-campaign" element={<UploadPage />} />
              <Route path="/email-campaign/upload" element={<UploadPage />} />
              <Route
                path="/email-campaign/send-campaign"
                element={<SendCampaignPage />}
              />
              <Route
                path="/email-campaign/all-documents"
                element={<AllDocumentsPage />}
              />
              <Route
                path="/email-campaign/all-campaigns"
                element={<AllCampaignsRoute />}
              />
              <Route
                path="/email-campaign/scorecard/:batchId"
                element={<ScorecardPage />}
              />
              <Route
                path="/email-campaign/conversations/:batchId"
                element={<ConversationsPage />}
              />
              <Route path="/may2Interview" element={<HiringLandingPage />} />
              <Route path="/walkin-journey" element={<WalkInJourneyPage />} />
              <Route
                path="/DRAcertification"
                element={<DRACertificationLanding />}
              />

              {/* ===================================================== */}
              {/* ✅ PROTECTED MAIN APP ROUTES (/main) */}
              {/* ===================================================== */}
              <Route
                path="/main"
                element={
                  <RequireAuth>
                    <Content1 />
                  </RequireAuth>
                }
              >
                {/* Default */}
                <Route
                  index
                  element={<Navigate to="/main/dashboard/products" replace />}
                />
                <Route
                  path="/main/dashboard/accomdation-gpt"
                  element={<AccomidationGpt />}
                />
                <Route
                  path="/main/dashboard/applicationsupport-gpt"
                  element={<ApplicationSupport />}
                />
                <Route
                  path="/main/dashboard/preparation-gpt"
                  element={<PreparationGpt />}
                />
                <Route
                  path="/main/dashboard/foreign-exchange"
                  element={<ForeignExchange />}
                />
                <Route
                  path="/main/dashboard/informationaboutcountries-gpt"
                  element={<InformationAboutCountries />}
                />
                <Route
                  path="/main/dashboard/loans-gpt"
                  element={<LoansGpt />}
                />
                <Route
                  path="/main/dashboard/logistics-gpt"
                  element={<LogisticsGpt />}
                />
                <Route
                  path="/main/dashboard/accreditations-gpt"
                  element={<AccreditationsRecognization />}
                />
                <Route
                  path="/main/dashboard/barcodescanner"
                  element={<BarcodeScanner />}
                />
                <Route
                  path="/main/dashboard/placements-gpt"
                  element={<PlacementsGpt />}
                />
                <Route
                  path="/main/dashboard/qualificationspecialization-gpt"
                  element={<QualificationSpecializationGPT />}
                />{" "}
                <Route
                  path="/main/dashboard/courses-gpt"
                  element={<CoursesGpt />}
                />{" "}
                <Route
                  path="/main/dashboard/universities-gpt"
                  element={<University />}
                />
                <Route
                  path="/main/dashboard/offer-letter-samples"
                  element={<UniversityOffers />}
                />
                <Route
                  path="/main/dashboard/scholarships-gpt"
                  element={<ScholarshipGpt />}
                />
                <Route
                  path="/main/dashboard/reviews-gpt"
                  element={<ReviewsGpt />}
                />
                <Route
                  path="/main/job-analysis-result"
                  element={<JobAnalysisResult />}
                />
                <Route path="/main/exam" element={<ExamPage />} />
                <Route
                  path="/main/exam/question/:questionNumber"
                  element={<ExamQuestionPage />}
                />
                <Route
                  path="/main/exam/results"
                  element={<ExamResultsPage />}
                />
                <Route path="/main/dashboard/home" element={<Home />} />
                <Route path="/main/dashboard/rice-gpt" element={<RiceGpt />} />
                <Route
                  path="/main/dashboard/universitiesagents-gpt"
                  element={<UniversityAgents />}
                />
                <Route path="/main/dashboard/visa-gpt" element={<VisaGpt />} />
                {/* Internal */}
                <Route path="dashboard/:tab" element={<DashboardMain />} />
                <Route path="dashboard/myservices" element={<ServicesPage />} />
                <Route path="dashboard/myblogs" element={<BlogsPage />} />
                <Route path="jobdetails" element={<JobDetails />} />
                <Route path="jobdetails/:id" element={<JobDetails />} />
                <Route path="caserviceitems" element={<CAServicesItems />} />
                <Route path="cartcaservice" element={<CartCaCsService />} />
                <Route path="servicecalist" element={<ServiceCAList />} />
                <Route path="servicedashboard" element={<ServiceDashboard />} />
                <Route
                  path="services/Freechatgpt"
                  element={<FreeChatGPTmain />}
                />
                <Route
                  path="services/myrotary"
                  element={<MyRotaryServices />}
                />
                <Route path="services/bmvcoin" element={<BMVCOINmain />} />
                <Route
                  path="services/freesample-steelcontainer"
                  element={<FreeSample />}
                />
                <Route
                  path="services/machines-manufacturing"
                  element={<MachinesManufacturingServices />}
                />
                <Route path="service/oxyloans-service" element={<OxyLoans />} />
                <Route
                  path="services/freeai-genai"
                  element={<FreeAiandGenAi />}
                />
                <Route
                  path="services/legalservice"
                  element={<LegalService />}
                />
                <Route
                  path="services/we-are-hiring"
                  element={<HiringService />}
                />
                {/* Wallet / Orders / Profile etc (already protected by /main) */}
                <Route path="wallet" element={<MyWalletPage />} />
                <Route path="myorders" element={<MyOrders />} />
                <Route
                  path="/main/freelanceappliedlist"
                  element={<FreelancersByUserId />}
                />
                <Route path="profile" element={<ProfilePage />} />
                <Route path="referral" element={<ReferralPage />} />
                <Route path="bulkinvite" element={<BulkInvite />} />
                <Route path="google" element={<GmailContactsScreen />} />
                <Route path="mycart" element={<CartPage />} />
                <Route path="agent-offers" element={<AgentComboOffersPage />} />
                <Route path="freelanceform" element={<FreelancerForm />} />
                <Route path="addblogs" element={<AddBlog />} />
                <Route
                  path="services/:id/:type"
                  element={<CampaignDetails />}
                />
                <Route path="blog/:id/:type" element={<BlogDetails />} />
                <Route path="viewjobdetails" element={<JobViewPage />} />
                <Route path="viewjobdetails/:id" element={<JobViewPage />} />
                <Route
                  path="viewjobdetails/:id/:company"
                  element={<JobViewPage />}
                />
                <Route path="subscription" element={<SubscriptionPage />} />
                <Route path="writetous" element={<WriteToUs />} />
                <Route path="writetous/:id" element={<WriteToUs />} />
                <Route path="crypto" element={<MyCrypto />} />
                <Route path="tickethistory" element={<TicketHistoryPage />} />
                <Route path="search-main" element={<SearchMain />} />
                <Route path="checkout" element={<CheckoutPage />} />
                <Route
                  path="manageaddresses"
                  element={<ManageAddressesPage />}
                />
                <Route
                  path="bharath-aistore/agents"
                  element={<AllAgentsPage />}
                />
                <Route path="create-aiagent" element={<CreateAgentWizard />} />
                <Route path="bharat-expert" element={<CreateAgentMain />} />
                <Route path="appliedjobs" element={<AppliedJobs />} />
                <Route path="agentcreate" element={<QuickAgentCreate />} />
                <Route
                  path="usercreateaistore"
                  element={<AgentStoreManager />}
                />
                <Route path="chatbasedagent" element={<ChatBasedAgent />} />
                <Route
                  path="chatinterface/assistant/:id/:agentId"
                  element={<ChatInterface1 />}
                />
                {/* ✅ Deep link route (your requirement) */}
                <Route
                  path="itemsdisplay/:itemId"
                  element={<ItemDisplayPage />}
                />
              </Route>
              {/* ===================================================== */}
              {/* ✅ PARTNER ROUTES */}
              {/* ===================================================== */}
              <Route path="/partnerlogin" element={<PartnerLogin />} />
              <Route path="/home" element={<PartnerHome />}>
                <Route index element={<MainPage />} />
                <Route path="newOrders/:status" element={<NewOrders />} />
                <Route path="acceptedOrders/:status" element={<NewOrders />} />
                <Route path="assignedOrders/:status" element={<NewOrders />} />
                <Route path="orderDetails" element={<OrderDetailsPage />} />
                <Route path="allOrders" element={<AllOrders />} />
                <Route path="addvehicle" element={<VehicleManagement />} />
                <Route path="dbList" element={<DeliveryBoyList />} />
                <Route path="queryManagement" element={<AllQueries />} />
                <Route path="marketreport" element={<MarketReport />} />
                <Route path="scan-qr" element={<BarcodeScanner />} />
                <Route path="itemsList" element={<PartnerItemsList />} />
                <Route path="dbOrderList" element={<DbOrderDetails />} />
                <Route path="feedback" element={<FeedbackDashboard />} />
                <Route path="exchangeorders" element={<ExchangeOrdersPage />} />
                <Route path="orderReport" element={<OrderReport />} />
                <Route path="orderstats" element={<OrderStatsDashboard />} />
                <Route path="updatestock" element={<StockUpdate />} />
                <Route path="versionUpdate" element={<VersionUpdate />} />
                <Route path="updateoffers" element={<OfferImagesUpdate />} />
                <Route path="addReference" element={<AddReference />} />
                <Route path="stockdetails" element={<StockTable />} />
                <Route
                  path="cartamountbasedorderplaces"
                  element={<WalletEligibilitySlabs />}
                />
                <Route
                  path="createFromImageText"
                  element={<CreateFromImageText />}
                />
              </Route>

              {/* ===================================================== */}
              {/* ✅ ADMIN ROUTES */}
              {/* ===================================================== */}
              <Route path="/admin" element={<Login />} />
              <Route path="/adminRegister" element={<Register />} />
              <Route path="/admin" element={<AdminSidebar />}>
                <Route path="dashboard" element={<Admin />} />
                <Route path="registeredUsers" element={<RegisteredUser />} />
                <Route path="allqueries" element={<AllQueries />} />
                <Route
                  path="allcampaignsdetails"
                  element={<AllCampaignsDetails />}
                />
                <Route path="campaignsadd" element={<CampaignsAdd />} />
                <Route path="kukatpally" element={<AllKukatpallyDataPage />} />
                <Route path="wearehiringadd" element={<WeAreHiringAdd />} />
                <Route path="addleaguejourney" element={<AddLeagueJourney />} />
                <Route path="advocates" element={<AdvocatesDataPage />} />
                <Route path="talwardata" element={<TalwarDataPage />} />
                <Route path="mumbaidata" element={<MumbaiDataPage />} />
                <Route
                  path="assignedtalwarData"
                  element={<TalwarAssignedDataPage />}
                />
                <Route
                  path="sendpollbasedrewards"
                  element={<SendPollBasedRewards />}
                />
                <Route
                  path="viewpollbasedrewards"
                  element={<ViewPollBasedRewards />}
                />
                <Route path="assignedData" element={<AssignedDataPage />} />
                <Route
                  path="userOrdersIntegration"
                  element={<UserOrdersIntegration />}
                />
                <Route
                  path="rammohandarisa"
                  element={<RamMohanDarisaAgents />}
                />
                <Route
                  path="sudheervakkalagadda"
                  element={<SudheerVakkalagadda />}
                />
                <Route
                  path="kukatpallyassignedData"
                  element={<KukatpallyAssignedDataPage />}
                />
                <Route path="addjobs" element={<AddJob />} />
                <Route
                  path="helpDeskUsers"
                  element={<HelpDeskUsersDashboard />}
                />
                <Route path="dataAssigned" element={<DataAssigned />} />
                <Route path="referredData" element={<ReferredData />} />
                <Route path="orderReport" element={<OrderReport />} />
                <Route path="feedback" element={<FeedbackDashboard />} />
                <Route path="helpdashboard" element={<HelpDeskDashboard />} />
                <Route path="allroleblogs" element={<RoleBasedBlogsList />} />
                <Route path="addroleblogs" element={<AddRoleBasedBlog />} />
                <Route path="todaycalls" element={<CallerHistoryPage />} />
                <Route path="addblogs" element={<AddBlog />} />
                <Route path="orderstats" element={<OrderStatsDashboard />} />
                <Route path="updatestock" element={<StockUpdate />} />
                <Route
                  path="superAdminComments"
                  element={<SuperAdminComments />}
                />
                <Route path="pincodeorders" element={<OrdersByPincode />} />
                <Route path="cbsdata" element={<CbsDataPage />} />
                <Route path="alljobdetails" element={<JobsAdminPage />} />
                <Route path="userAppliedJobs" element={<UserAppliedJob />} />
                <Route path="assistants" element={<AssistantDashboard />} />
                <Route
                  path="conversation/:assistantId"
                  element={<AssistantOverview />}
                />
                <Route path="createassistant" element={<CreateAssistant />} />
                <Route path="vectorstore" element={<VectorStorePage />} />
                <Route
                  path="partners-dashboard"
                  element={<Partnersdasboard />}
                />
                <Route
                  path="freelance-requirements"
                  element={<AdminRequirementList />}
                />
                <Route
                  path="assigned-freelancers/:companyId"
                  element={
                    <AssignedFreelancerAdmin
                      companyId=""
                      isMobileScreen={false}
                    />
                  }
                />
              </Route>

              {/* ✅ LANDING */}
              {/* ===================================================== */}
              <Route path="/" element={<CurrentLandingPage />} />

              {/* ===================================================== */}
              {/* ✅ FALLBACK */}
              {/* ===================================================== */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </Suspense>
      </SearchProvider>
    </CartProvider>
  );
};

export default App;
